<re-label [formConfig]="formConfig" [disabled]="disabledState"></re-label>
<button
  class="btn"
  type="button"
  [disabled]="disabledState || (showProgress && !loadError)"
  (click)="input.click()"
  (blur)="onBlur($event)">
  <img
    src="assets/images/cmi-icons/icon-reg_arrow-up-from-bracket.svg"
    alt="upload icon"
    height="16"
    width="16" />
  Choose File
</button>
<input #input type="file" [attr.accept]="formConfig.accept" (input)="onChange($event)" />
@if (file || showProgress || loadError) {
  <section>
    @if (formConfig.images) {
      @if (!!srcFile) {
        <div>
          <img [src]="srcFile" alt="selected image" height="52" width="92" />
        </div>
      } @else {
        <div class="re-empty">
          <img
            src="assets/images/cmi-icons/icon-reg_image.svg"
            alt="empty image"
            height="16"
            width="16" />
        </div>
      }
    }
    @if (!formConfig.images) {
      <div class="re-file-lines">
        <img
          src="assets/images/cmi-icons/icon-reg_file-lines.svg"
          alt="file image"
          height="16"
          width="16" />
      </div>
    }
    <div>
      <div>
        <h5 [class.re-with-progress]="showProgress">{{ filename }}</h5>
        @if (showProgress) {
          <span [class.re-error]="loadError">{{ progressPercentage }}</span>
        }
      </div>
      @if (showProgress) {
        <div class="progress">
          <div
            class="progress-bar"
            [class.re-error]="loadError"
            [style.width]="progressPercentage"
            role="progressbar"
            aria-label="Upload progress"
            [attr.aria-valuenow]="progressNow"
            aria-valuemin="0"
            [attr.aria-valuemax]="progressMax"></div>
        </div>
      }
      <div>
        @if (filesize > 0 && !loadError) {
          <span class="re-filesize">{{ filesizeText }}</span>
        }
        @if (loadError) {
          <span class="re-error">{{ loadErrorMessage }}</span>
        }
      </div>
    </div>
    <div>
      @if (!showProgress && !loadError) {
        <re-icon-button
          class="re-tertiary"
          [disabled]="disabledState"
          iconSrc="assets/images/cmi-icons/icon-reg_trash.svg"
          iconAlt="delete file"
          (clicked)="onDelete($event)"></re-icon-button>
      }
      @if (showProgress || loadError) {
        <re-icon-button
          class="re-tertiary"
          iconSrc="assets/images/cmi-icons/icon-reg_xmark.svg"
          iconAlt="abort upload"
          (clicked)="onAbort($event)"></re-icon-button>
      }
    </div>
  </section>
}
@if (displayErrorMessage()) {
  <div class="form-text">{{ errorMessage }}</div>
}
